export default "__VITE_ASSET__CWKCtxSI__"